var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24992 4.99992C11.3211 4.99992 12.9999 6.67873 12.9999 8.74992C12.9999 10.8211 11.3211 12.4999 9.24992 12.4999C7.17873 12.4999 5.49992 10.8211 5.49992 8.74992C5.49992 6.67873 7.17873 4.99992 9.24992 4.99992ZM9.24992 3.33325C12.2416 3.33325 14.6666 5.75825 14.6666 8.74992C14.6666 9.94505 14.2796 11.0497 13.624 11.9455L16.9312 15.2527C17.0939 15.4154 17.0939 15.6792 16.9312 15.8419L16.3419 16.4312C16.1792 16.5939 15.9154 16.5939 15.7527 16.4312L12.4455 13.124C11.5497 13.7796 10.4451 14.1666 9.24992 14.1666C6.25825 14.1666 3.83325 11.7416 3.83325 8.74992C3.83325 5.75825 6.25825 3.33325 9.24992 3.33325Z",
    fill: "#343434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFind);
export default __webpack_public_path__ + "static/media/find.171bbde5ecd1ee502f579eae331c559f.svg";
export { ForwardRef as ReactComponent };